import { render, staticRenderFns } from "./partnerRegularSalePanel.vue?vue&type=template&id=83048300&"
import script from "./partnerRegularSalePanel.vue?vue&type=script&lang=ts&"
export * from "./partnerRegularSalePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports